<script>
  export let config
  
  import { onMount, createEventDispatcher } from 'svelte'
  import { getPoints } from '$services/api.js'
  import download from '$assets/svg/download.svg'
  import close from '$assets/svg/close.svg'

  import { DataTable, Loading } from "carbon-components-svelte"
  import Icon from 'svelte-icon'
  import Mousetrap from 'mousetrap'
  
  import L from 'leaflet'

  let loading = true
  let mapContainer, mapComponent
  let pointsFile = '', points = []

  const dispatch = createEventDispatcher()

  Mousetrap.bind('escape', closePointsViewer)

  function closePointsViewer () {
    dispatch('closePointsViewer', {})
  }


  function downloadPointsFile () {

    let lines = ['id,lat,lng']

    points.forEach(p => {
      lines.push(`${p.id},${p.lat},${p.lng}`)
    })

    lines = lines.join('\n')
    
    let element = document.createElement('a')
    element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(lines))
    element.setAttribute('download', pointsFile)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
    
  }
  

  onMount(() => {
    if (config.metadatas.kind.includes('custom')) {
      pointsFile = config.custom_pipeline.config.points_file
    } else {
      pointsFile = config.input.points_file
    }
    
    mapComponent = L.map(mapContainer, { preferCanvas: true }).setView([45.758958278714864, 3.130122224231804], 6)
    L.tileLayer(
      'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
      {
        attribution: '',
        subdomains: '',
        maxZoom: 14,
      }
    ).addTo(mapComponent)

    let bounds = L.latLngBounds()

    getPoints(pointsFile).then(res => {

      function sortPoints (a, b) {
	if (a.id < b.id) return -1
	else if (a.id > b.id) return 1
	return 0
      }
      
      points = res.points.sort(sortPoints)

      if (points.length > 1000) {
	loading = false
	return
      }
      
      points.forEach(p => {
	if (p.lon) p['lng'] = p.lon
	let marker = L.circleMarker([p.lat, p.lng], {
          color: '#0f62fe',
          radius: 5,
	})
            .bindTooltip(`<b>${p.id}</b>`)
	    .addTo(mapComponent)
	bounds.extend([p.lat, p.lng])
      })
      
      mapComponent.fitBounds(bounds)

      loading = false
    })
  })
  </script>

<svelte:head>
  <link rel="stylesheet" href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
        integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
        crossorigin=""/>
</svelte:head>

<main id="points-viewer">
  {#if loading}
    <Loading />
  {/if}
  
  <div id="page-header">
    <h1>Points for {config.metadatas.name}</h1>
    <div id="header-controls">
      <button on:click={downloadPointsFile} class="clear">
	<Icon class="btn-icon icon "
	      data={download} fill="#00000000"
	      stroke="#fff" size="40px" />
	</button>
      <button on:click={closePointsViewer} class="clear">
	<Icon class="btn-icon icon "
	    data={close} fill="#00000000"
	    stroke="#fff" size="40px" />
      </button>
    </div>
  </div>
  <div id="points-viewer-contents">

    {#if points.length < 1000}
      <div id="points-map" bind:this={mapContainer}></div>

      <div id="points-list">
	<DataTable
	  headers={[
	  { key: 'id', value: 'Name' },
	  { key: 'lat', value: 'Latitude' },
	  { key: 'lng', value: 'Longitude' }
	  ]}
	  rows={points}
	  ></DataTable>
      </div>
    {:else}
      <div id="points-viewer-contents-error">
	There is more than 1000 points ({ points.length }), not displaying them...
      </div>
    {/if}
    
    
  </div>
</main>

<style lang="scss">
  @import "src/variables.scss";

  #page-header {
    display: flex;
    justify-content: space-between;
    
    #header-controls {
      display: flex;
      align-items: center;
      margin-right: 20px;
    }
  }
  
  #points-viewer {
    z-index: 100000;
    background-color: $gray10;
    height: 95vh;
    width: 97vw;
    position: fixed;
    top: 5vh;
    left: 3vw;

    #points-viewer-contents {
      display: flex;
      justify-content: space-around;
      
      #points-map {
        height: 87vh;
        width: 60%;
      }

      #points-list {
	width: 35%;
	height: 87vh;

	overflow-y: scroll;
      }

      #points-viewer-contents-error {
	padding-top: 25vh;
	color: $error;
	font-size: 2em;
	font-weight: bold;
      }
    }
  }
</style>
